import { inject, Injectable } from "@angular/core";
import { GoogleCalendarAvailabilityService } from "../../../api/services";
import { Observable } from "rxjs";
import { ResponseAvailabilityDto } from "../../../api/models";
import { GoogleCalendarAvailabilityControllerFindAllByEmail$Params } from "../../../api/fn/google-calendar-availability/google-calendar-availability-controller-find-all-by-email";
import { environment } from "../../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class GoogleCalendarAvailabilityApiService {
  /** Service for interacting with the Google Calendar Availability API. */
  private readonly _googleCalendarAvailabilityService: GoogleCalendarAvailabilityService =
    inject(GoogleCalendarAvailabilityService);

  /**
   * Retrieves the availability of a user based on their email.
   *
   * @param email The user's email address.
   * @returns Observable containing the availability data.
   */
  public getAvailability$(email: string): Observable<ResponseAvailabilityDto> {
    const params: GoogleCalendarAvailabilityControllerFindAllByEmail$Params = {
      tenant: environment.tenant,
      email,
    };

    return this._googleCalendarAvailabilityService.googleCalendarAvailabilityControllerFindAllByEmail(
      params,
    );
  }
}
